import { accounts } from '../account/data'
import { advertisers } from '../advertisers/data'
import { applications } from '../application/data'
import { categoryFilters } from '../category-filter/data'
import { demandBlockings } from '../demand-blockings/data'
import { experiments } from '../experiments/data'
import { placements } from '../placement/data'
import { products } from '../products/data'
import { publishers } from '../publisher/data'
import { virtualCurrencySales } from '../virtual-currency-sale/data'
import { virtualCurrencies } from '../virtual-currency/data'
import Entity from './entity'

const db = {
  account: new Entity(accounts),
  application: new Entity(applications),
  categoryFilter: new Entity(categoryFilters),
  // @ts-expect-error: doesn't have an ID
  demandBlockings: new Entity(demandBlockings),
  placement: new Entity(placements),
  experiment: new Entity(experiments),
  publisher: new Entity(publishers),
  advertisers: new Entity(advertisers),
  products: new Entity(products),
  vc: new Entity(virtualCurrencies),
  vcs: new Entity(virtualCurrencySales),
}

export default db
